import React, { Component } from 'react'

class TextArea extends Component {
  render() {
    return (
      <textarea defaultValue={this.props.value}  className={this.props.className} id={this.props.id} name={this.props.name} onChange={this.props.onChange} maxLength={this.props.maxLength} ></textarea>
    )
  }
}
TextArea.defaultProps = {
  className: "form-control",
  name:"",
}
export default TextArea;



// WEBPACK FOOTER //
// ./src/shared/components/Input/text_area.js